<div class="section">
  <div class="heading-wrapper">
    <h4>{{ 'pages.client.activities.title' | translate }}</h4>
    @if (showDelete && !client.isDeleted) {
      <div class="actions align-items-center gap-0">
        <div class="actions">
          <app-delete-client [client]="client" (save)="onDelete($event)" />
        </div>
        <app-tooltip [marginBottom]="false" position="left" text="deleteUser" />
      </div>
    }
  </div>
  <div class="lna-row">
    <div class="value-wrapper">
      <div class="form-label_wrapper">
        <p class="form-label">
          {{ 'pages.client.activities.registrationDate' | translate }}
        </p>
        <app-tooltip text="registrationDate" />
      </div>
      <p class="form-value">{{ formatDate(client.createdOn, true) }}</p>
    </div>
    <div class="value-wrapper">
      <div class="form-label_wrapper">
        <p class="form-label">
          {{ 'pages.client.activities.portalRegistrationDate' | translate }}
        </p>
        <app-tooltip text="portalRegistrationDate" />
      </div>
      <p class="form-value">{{ client.registrationDate ? formatDate(client.registrationDate, true) : '-' }}</p>
    </div>
    @if (client.clientType !== 'Organization') {
      <div class="value-wrapper">
        <div class="form-label_wrapper">
          <p class="form-label">
            {{ 'pages.client.activities.registratorEmployerName' | translate }}
          </p>
          <app-tooltip text="registratorEmployerName" />
        </div>
        <p class="form-value">{{ client.creatorName || '-' }}</p>
      </div>
    }
  </div>
  @if (client.clientType !== 'Organization') {
    <div class="lna-row no-margin">
      <div class="value-wrapper">
        <div class="form-label_wrapper">
          <p class="form-label">
            {{ 'pages.client.activities.authenticationType' | translate }}
          </p>
          <app-tooltip text="authenticationType" />
        </div>
        <p class="form-value">
          {{ getAuthenticationTypeName(client.authenticationType!) || '-' }}
        </p>
      </div>
      @if (client.isDeleted) {
        <div class="value-wrapper">
          <div class="form-label_wrapper">
            <p class="form-label">
              {{ 'pages.client.activities.deleteReason' | translate }}
            </p>
            <app-tooltip text="deleteReason" />
          </div>
          <p class="form-value">{{ client.deleteReason || '-' }}</p>
        </div>
      }
    </div>
  }
</div>

<div class="section no-padding">
  <div class="heading-wrapper">
    <h4>{{ 'pages.client.activities.sesionTableTitle' | translate }}</h4>
  </div>
  @if (isLoginListLoading) {
    <app-spinner [isLoading]="isLoginListLoading" />
  } @else {
    @if (isLegalEntity) {
      @if (legalEntityLogins?.length === 0) {
        <div class="empty-table">
          <p>{{ 'components.table.noLogins' | translate }}</p>
        </div>
      } @else {
        <table class="session-table">
          <thead>
            <tr>
              <td>{{ 'pages.client.activities.sessionDateTime' | translate }}</td>
              <td>{{ 'pages.client.activities.sessionOfficer' | translate }}</td>
            </tr>
          </thead>
          <tbody>
            @for (login of visibleLegalEntityLogins; track login.id) {
              <tr>
                <td>{{ formatDate(login.loggedOn, false) }}</td>
                <td>{{ login.fullName }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
    } @else {
      @for (clientLogin of visibleLogins; track clientLogin.id) {
        <div class="login-row">
          <p class="login-date">{{ formatDate(clientLogin.loggedOn, false) }}</p>
        </div>
      }

      @if (clientLogins?.length === 0) {
        <div class="empty-table">
          <p>{{ 'components.table.noLogins' | translate }}</p>
        </div>
      }
    }

    @if (!isLoginListLoading && totalLogins > 10) {
      <div class="pagination-wrapper">
        <p class="total">
          {{ 'components.table.total' | translate }}
          {{ totalLogins }}
        </p>
        <ngb-pagination
          [(page)]="page"
          [pageSize]="pageSize"
          [collectionSize]="totalLogins"
          [maxSize]="5"
          [ellipses]="true"
          (pageChange)="handlePageChange($event)" />
        <select class="page-size" (change)="onPageSizeChange($event)">
          <option [selected]="pageSize === 10" [value]="10">10 / {{ 'components.table.pageSize' | translate }}</option>
          <option [selected]="pageSize === 20" [value]="20">20 / {{ 'components.table.pageSize' | translate }}</option>
          <option [selected]="pageSize === 50" [value]="50">50 / {{ 'components.table.pageSize' | translate }}</option>
          <option [selected]="pageSize === 100" [value]="100">100 / {{ 'components.table.pageSize' | translate }}</option>
        </select>
      </div>
    }
  }
</div>
